import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ProductNomenclatureModel } from '../models/product.nomenclature.model';
import { PrintGroupModel } from '../models/product.printgroup.model';
import { ProductCategoryService } from '../services/productcategory.service';
import { environment } from 'src/environments/environment';
import { SpinnerService } from '../services/spinner.service';


@Component({
  selector: 'app-nomenclature',
  templateUrl: './nomenclature.component.html',
  styleUrls: ['./nomenclature.component.css']
})
export class NomenclatureComponent implements OnInit {

  productSubCategoryid: string;
  printGroup: string;
  public productNomenclatures: ProductNomenclatureModel[] = [];
  baseUrl = environment.baseUrl;
  isEcotainer: boolean;
  isCompliancePackaging: boolean;
  displayName:string;
  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private service: ProductCategoryService,
    private spinner: SpinnerService
  ) {

    this.productSubCategoryid = this.route.snapshot.params.id;
    this.displayName = decodeURI(this.route.snapshot.queryParams.name);
    //console.log(this.route.params);
    this.printGroup = this.route.snapshot.params.printGroup
    this.isEcotainer = this.route.snapshot.params.isEcotainer;
    this.isCompliancePackaging = this.route.snapshot.params.isCompliancePackaging;
    //console.log('Is Ecotainer:' + this.isEcotainer);
    //console.log('Is Compliance:' + this.isCompliancePackaging);
    

  }

  ngOnInit(): void {
    this.spinner.showSpinner();
    this.service.getNomenclaturesFromSubCategoryAndPrintGroup(this.productSubCategoryid, this.printGroup, this.isEcotainer, this.isCompliancePackaging)
      .subscribe(
        (data => {
          this.productNomenclatures = data;
          //console.log(this.productNomenclatures);
        }),
        (error => {
          console.log(error);
        })
      );
    this.spinner.hideSpinner();
  }

}
